import React from 'react';

interface InfoIconProps {
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const InfoIcon = ({ className, onClick, style }: InfoIconProps) => {
  return (
    <svg
      style={style}
      className={className}
      width="16px"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.28736C4.29271 1.28736 1.28736 4.29271 1.28736 8C1.28736 11.7073 4.29271 14.7126 8 14.7126C11.7073 14.7126 14.7126 11.7073 14.7126 8C14.7126 4.29271 11.7073 1.28736 8 1.28736ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 7.35632C8.35549 7.35632 8.64368 7.64451 8.64368 8V10.9425C8.64368 11.298 8.35549 11.5862 8 11.5862C7.64451 11.5862 7.35632 11.298 7.35632 10.9425V8C7.35632 7.64451 7.64451 7.35632 8 7.35632ZM8 4.41379C7.64451 4.41379 7.35632 4.70198 7.35632 5.05747C7.35632 5.41296 7.64451 5.70115 8 5.70115H8.00736C8.36285 5.70115 8.65103 5.41296 8.65103 5.05747C8.65103 4.70198 8.36285 4.41379 8.00736 4.41379H8Z"
        fill="currentColor"
      />
    </svg>
  );
};
